(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus/assets/javascripts/views/content/activesuspensionslist.js') >= 0) return;  svs.modules.push('/modules/spelpaus/assets/javascripts/views/content/activesuspensionslist.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.spelpaus.views.ActiveSuspensionsList = Marionette.CollectionView.extend({
    childView: svs.spelpaus.views.ActiveSuspension,
    behaviors: {
      ServerSideRendering: {}
    }
  });
})(Backbone, _, svs);

 })(window);